import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { resetAuth } from "../reducers/authSlice";
import { API_URL, getFromStorage, STORAGE_KEYS } from "../helpers";
import { generateEncryptedKeyBody, generateSEKAndHash } from "./crypto";

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers, { getState }) => {
    const { token, tempToken } = getState().auth || {};

    const encryptData = generateSEKAndHash(token || tempToken || null);
    const currency = getFromStorage(STORAGE_KEYS.currency);
    const currentLang = getFromStorage(STORAGE_KEYS.language);

    if (encryptData) {
      headers.set("hash", encryptData?.hash);
      headers.set("sek", encryptData?.sek);
    }

    headers.set(
      "lang",
      currentLang === "ar" ? "ar" : currentLang === "ru" ? "ru" : "en"
    );
    headers.set("deviceType", "web");
    headers.set("currency", currency ? currency : "AED");

    return headers;
  },
});

const baseQueryWithAuth = async (args, api, extraOptions) => {
  var body = "";
  if (args?.body) {
    body = generateEncryptedKeyBody(args?.body);
  }
  console.log(api, "body");
  console.log(args, "args");

  // console.log(`Endpoint - ${api?.endpoint} at ${moment().format('HH:mm:ss')}`);
  const data = args?.body
    ? { body, method: args.method, url: args.url }
    : { method: args.method, url: args.url };

  const result = await baseQuery(data, api, extraOptions);

  if (result.error?.status === 400) {
    const errors = Object.values(result?.error?.data || {});
    console.log({ errors });

    if (errors?.length > 1 && errors[1] === 400) {
      return result;
    }

    if (errors?.length) {
      const error = errors[0];
      if (Array.isArray(error)) {
        console.log(error[0]);
      }
    }
  }

  if (result.error?.status === 401) {
    api.dispatch(resetAuth());
    if (typeof window !== "undefined") {
      window.location.replace("/");
    }
  }

  return result;
};

const emptySplitApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: ["UNAUTHORIZED", "UNKNOWN_ERROR"],
  endpoints: () => ({}),
});

export default emptySplitApi;
